import { Grid, styled } from '@mui/material';

import { colors } from '@/theme/variables';

export const ViewItemRoot = styled(Grid)(({ theme }) => ({
  width: '100%',
  padding: '10px 0px',

  '& .label': {
    width: '100%',
    flex: 1,
    fontSize: '0.75rem',
    fontWeight: 400,
    color:
      theme.palette.mode === 'light' ? undefined : theme.palette.text.secondary,
  },

  '& .value': {
    flex: 1,
    fontSize: '0.875rem',
    fontWeight: 500,
    color:
      theme.palette.mode === 'light'
        ? colors.grey[80]
        : theme.palette.text.primary,
  },
  '& .value.is--email': {
    textTransform: 'none',
  },
}));
